import React, {
  useState,
  useContext,
  useMemo,
  useCallback,
  useEffect,
} from "react";
import { useForm } from "react-hook-form";
import { AppContexts } from "../../providers";
import { useHistory } from "react-router";
import { Icon, Image } from "uikit-react";
import UIkit from "uikit";
import moment from "moment";
import GoogleAutoComplete from "../common/GoogleAutoComplete";
import Tags from "./tags";
import PropertyDelete from "./delete.js";
import QRPart from "../common/Qrcode";

const TableRow = ({ guide, index, allTags }) => {
  const [setSelectedId, guideDestination, setGuideDestination] = useState(null);
  const DestinationContext = useContext(AppContexts.DestinationContext);
  const {
    updateRental,
    setRental,
    selectedFlags,
    setSelectedFlags,
    setIsNew,
    createRental,
  } = useContext(AppContexts.RentalsContext);
  const history = useHistory();

  const listDestinations = useMemo(() => {
    if (!DestinationContext.listDestinations) {
      return [];
    } else {
      return DestinationContext.listDestinations;
    }
  }, [DestinationContext.listDestinations]);

  const handleSelectedTags = async (selectedTags) => {
    let updated = { ...guide, tags: selectedTags };
    if (updated.hasOwnProperty("custom_macro_values"))
      delete updated["custom_macro_values"];
    try {
      await updateRental(updated.rental_id, updated);
    } catch (e) {
      console.log(e);
    }
  };

  const handleSelect = useCallback((event, index) => {
    setSelectedFlags((flags) => [
      ...flags.slice(0, index),
      event.target.checked,
      ...flags.slice(index + 1),
    ]);
  }, []);

  const handleMessageClone = async (objRental) => {
    const {
      rental_id,
      created_at,
      updated_at,
      attachments,
      ...objCloneRental
    } = objRental;
    objCloneRental.name += " - Cloned";
    objCloneRental.pms_id += " - Cloned";
    let rental = await createRental(objCloneRental);

  };

  const handleDetail = (rental) => {
    setRental(rental)
    history.push(`/unit_detail/${rental.rental_id}`);
  };

  return (
    <>
      <tr>
        <td>
          <div className="autosend-checkbox">
            <label htmlFor={`propertyCB${index}`}>
              <input
                type="checkbox"
                id={`propertyCB${index}`}
                checked={selectedFlags[index]}
                onChange={(event) => handleSelect(event, index)}
              />
            </label>
          </div>
        </td>
        <td>
          <div>
            <div className="semi-bold-font property-guide-name">
              {guide.pms_id === "" ? "Click to Add an ID" : guide.pms_id}
            </div>
          </div>
          <div className="uk-margin-very-small-top">
            <span>{guide.address}</span>
          </div>
        </td>
        <td className="hms-add-tag">
          <Tags
            value={guide.tags}
            all={allTags}
            onChange={(event) => handleSelectedTags(event, guide)}
          />
        </td>
        {/*
        <td className="hms-add-tag">
          <div className="uk-flex uk-flex-top">
            <div className="hms-add-tag">
              <button className="uk-button" type="button" aria-haspopup="true" aria-expanded="false"><img src="/images/group.svg" /></button>
              <div data-uk-dropdown="mode: click" className="guest-tags-dropdown uk-dropdown">
                <ul className="uk-nav uk-dropdown-nav tags-selector">
                  <li>
                    <label>
                      <input
                        className="uk-radio"
                        type="radio"
                        name="groupSelection"
                        value="Group 1 - Beachside Condos"
                        selected
                      />
                      Group 1 - Beachside Condos
                    </label>
                  </li>
                  <li>
                    <label>
                      <input
                        className="uk-radio"
                        type="radio"
                        name="groupSelection"
                        value="Group 2 - Gardenside Condos"
                        checked
                      />
                      Group 2 - Gardenside Condos
                    </label>
                  </li>
                  <li>
                    <label>
                      <input
                        className="uk-radio"
                        type="radio"
                        name="groupSelection"
                        value="Group 3 - Other"
                      />
                      Group 3 - Other
                    </label>
                  </li>
                </ul>
              </div>
            </div>
            <div className="hms-guest-tags">
              <div className="guest-tags">
                <div className="uk-inline zone">
                  Group 1 - Beachside Condos
                </div>
              </div>
            </div>
          </div>
        </td>
        */}        
        <td className="td-w-240 hms-action-btn">
          <div className="uk-inline">
            <button
              className="uk-button"
              type="button"
              uk-toggle={`target: #addPropertyGuide-modal`}
              onClick={() => {
                setIsNew(false);
                setRental(guide);
              }}
              uk-tooltip="Edit"
            >
              <img src="/images/edit.svg" />
            </button>
          </div>
          <div className="uk-inline">
            <button
              className="uk-button"
              uk-toggle="target: #modal-guest-detail"
              onClick={() => handleDetail(guide)}
              uk-tooltip="Detail"
            >
              <Image src="/images/detail.svg" />
            </button>
          </div>
          <div className="uk-inline">
            <button
              className="uk-button"
              onClick={() => handleMessageClone(guide)}
              uk-tooltip="Clone"
            >
              <Image src="/images/clone.svg" />
            </button>
          </div>
          <div className="uk-inline">
            <button
              className="uk-button"
              type="button"
              uk-toggle="target: #modal-property-delete"
              onClick={() => setRental(guide)}
              uk-tooltip="Delete"
            >
              <img src="/images/delete.svg" />
            </button>
          </div>
        </td>
      </tr>
      <PropertyDelete />
    </>
  );
};

export default TableRow;
